module.exports = __webpack_public_path__ + "af52615c7184c1d2c0c682732f078377.png";